import { render, staticRenderFns } from "./OrderAdditionalCosts.vue?vue&type=template&id=3eee260d&"
import script from "./OrderAdditionalCosts.vue?vue&type=script&lang=js&"
export * from "./OrderAdditionalCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports